import { Heading as ChakraHeading, HeadingProps } from "@chakra-ui/react";
import React from "react";

const Heading = ({ ...props }: HeadingProps) => {
  return <ChakraHeading {...props}>{props.children}</ChakraHeading>;
};

export default Heading;
